import { render, staticRenderFns } from "./common-record.vue?vue&type=template&id=2ed942ce&scoped=true"
import script from "./common-record.vue?vue&type=script&lang=js"
export * from "./common-record.vue?vue&type=script&lang=js"
import style0 from "./common-record.vue?vue&type=style&index=0&id=2ed942ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed942ce",
  null
  
)

export default component.exports